export const COMPANIES_BACK_URL = 'back-url';
export const COMPANIES_SCROLL_INDEX = 'companies-scroll-index';
export const NAVIGATED_FROM_COMPANY_BREADCRUMB = 'navigated-from-company-breadcrumb';

export const TOP_MATCH_LIMIT = 15;
export const AMPLITUDE_GS_API_KEY = import.meta.env.VITE_AMPLITUDE_GS_API_KEY || '';

export const SOURCING_AGENT_FORM_BASE =
  'https://docs.google.com/forms/d/e/1FAIpQLSctWwX4g1ul1Pg9h47odY5bEheek2aEm9cItoO-ylCPuAJjAA/viewform';

export const CONTACT_AGENT_BOOST_MEETING_URL = 'https://scheduler.zoom.us/brett-bazzini';
export const BRETT_30_MIN_MEETING_URL = 'https://scheduler.zoom.us/brett-bazzini/30-min-meeting';
